import { VEHICLE_MODULE_PREFIX } from '../constants';
export const VEHICLE_UPDATE_CUSTOM_VEHICLE_NAME = `${VEHICLE_MODULE_PREFIX}_UPDATE_CUSTOM_VEHICLE_NAME`;
export const VEHICLE_UPDATE_CUSTOM_VEHICLE_NAME_CHECKBOX = `${VEHICLE_MODULE_PREFIX}_UPDATE_CUSTOM_VEHICLE_NAME_CHECKBOX`;
export const onUpdateCustomVehicleNameAction = (payload) => ({
    type: VEHICLE_UPDATE_CUSTOM_VEHICLE_NAME,
    payload
});
export const onUpdateCustomVehicleNameCheckboxAction = () => ({
    type: VEHICLE_UPDATE_CUSTOM_VEHICLE_NAME_CHECKBOX,
    payload: null
});
//# sourceMappingURL=updateCustomVehicleAction.js.map